import manageProfileSopChangePasswordImage from "../../../assets/images/manage-profile-sop/manage-profile-sop-change-password.png";
import manageProfileSopEditProfileImage from "../../../assets/images/manage-profile-sop/manage-profile-sop-edit-profile.png";
import manageProfileSopProfileViewImage from "../../../assets/images/manage-profile-sop/manage-profile-sop-profile-view.png";

import type { ManageProfileSopImageConfig } from "../types";

export const MANAGE_PROFILE_SOP_IMAGES: Record<
  string,
  ManageProfileSopImageConfig
> = {
  "profile-view": {
    src: manageProfileSopProfileViewImage,
    altKey: "manage-profile-sop-image-profile-view-alt",
    altFallback:
      "Profile page showing personal details with sensitive fields redacted"
  },
  "edit-profile": {
    src: manageProfileSopEditProfileImage,
    altKey: "manage-profile-sop-image-edit-profile-alt",
    altFallback: "Edit your profile form with name and phone fields redacted"
  },
  "change-password": {
    src: manageProfileSopChangePasswordImage,
    altKey: "manage-profile-sop-image-change-password-alt",
    altFallback: "Password tab with fields for current and new password"
  }
};
